import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '../containers/Full.vue';
import MarketplaceContainer from '../containers/Marketplace.vue';
import MarketplacesCategoryContainer from '../containers/MarketplacesCategory.vue';

// PAGES
import Dashboard from '../pages/Dashboard.vue';
import Error404 from '../pages/Error404.vue';
import Error500 from '../pages/Error500.vue';
import Login from '../pages/Login.vue';
import MarketplacesCategories from '../pages/MarketplacesCategories.vue';
import MarketplacesCategory from '../pages/MarketplacesCategory.vue';
import MarketplacesCategoryTemplates from '../pages/MarketplacesCategoryTemplates.vue';
import Marketplaces from '../pages/Marketplaces.vue';
import Accounts from '../pages/Accounts.vue';
import CreateAccount from '../pages/AccountCreate.vue';
import EditAccount from '../pages/AccountEdit.vue';
import Users from '../pages/Users.vue';
import CreateUser from '../pages/UserCreate.vue';
import EditUser from '../pages/UserEdit.vue';
import MarketplaceMain from '../pages/MarketplaceMain.vue';
import MarketplaceCredentialFields from '../pages/MarketplaceCredentialFields.vue';
import MarketplaceFields from '../pages/MarketplaceFields.vue';
import MarketplaceTemplates from '../pages/MarketplaceTemplates.vue';
import ProductsColorsMaps from '../pages/ProductsColorsMaps.vue';
import ProductsSizesMaps from '../pages/ProductsSizesMaps.vue';

import UserTokenService from '../services/AdminsTokensService';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'open active',
  mode: 'history',
  root: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Home',
      path: '/',
      redirect: '/dashboard',
      component: Full,
      meta: {
        auth: true,
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            auth: true,
            breadcrumbs: 'Dashboard',
          },
        },
        {
          name: 'Marketplaces',
          path: 'marketplaces',
          component: {
            render(c) { return c('router-view'); },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Marketplaces',
          },
          children: [
            {
              path: 'marketplaces',
              component: {
                render(c) { return c('router-view'); },
              },
              meta: {
                auth: true,
              },
              children: [
                {
                  path: '',
                  name: 'MarketplacesMarketplaces',
                  component: Marketplaces,
                  meta: {
                    auth: true,
                  },
                },
                {
                  path: ':marketplaceId',
                  component: MarketplaceContainer,
                  meta: {
                    auth: true,
                  },
                  children: [
                    {
                      path: '',
                      name: 'MarketplaceMain',
                      meta: {
                        auth: true,
                      },
                      component: MarketplaceMain,
                    },
                    {
                      path: 'credential-fields',
                      name: 'MarketplaceCredentialFields',
                      meta: {
                        auth: true,
                      },
                      component: MarketplaceCredentialFields,
                    },
                    {
                      path: 'fields',
                      name: 'MarketplaceFields',
                      meta: {
                        auth: true,
                      },
                      component: MarketplaceFields,
                    },
                    {
                      path: 'templates',
                      name: 'MarketplaceTemplates',
                      meta: {
                        auth: true,
                      },
                      component: MarketplaceTemplates,
                    },
                  ],
                },
              ],
            },
            {
              path: 'categories',
              component: {
                render(c) { return c('router-view'); },
              },
              meta: {
                auth: true,
              },
              children: [
                {
                  path: '',
                  name: 'MarketplacesCategories',
                  component: MarketplacesCategories,
                  meta: {
                    auth: true,
                    breadcrumbs: 'Categories',
                  },
                },
                {
                  path: ':categoryId',
                  component: MarketplacesCategoryContainer,
                  meta: {
                    auth: true,
                  },
                  children: [
                    {
                      path: '',
                      name: 'MarketplacesCategory',
                      meta: {
                        auth: true,
                      },
                      component: MarketplacesCategory,
                    },
                    {
                      path: 'templates',
                      name: 'MarketplacesCategoryTemplates',
                      meta: {
                        auth: true,
                      },
                      component: MarketplacesCategoryTemplates,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Users',
          path: 'users',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Users',
          },
          children: [
            {
              name: 'UsersAccounts',
              path: 'accounts',
              component: Accounts,
              meta: {
                auth: true,
                breadcrumbs: 'Accounts',
              },
              children: [
                {
                  name: 'UsersCreateAccount',
                  path: 'create',
                  component: CreateAccount,
                  meta: {
                    auth: true,
                  },
                },
                {
                  name: 'UsersEditAccount',
                  path: ':id',
                  component: EditAccount,
                  meta: {
                    auth: true,
                  },
                },
              ],
            },
            {
              name: 'UsersUsers',
              path: 'users',
              component: Users,
              meta: {
                auth: true,
              },
              children: [
                {
                  name: 'UsersCreateUser',
                  path: 'create',
                  component: CreateUser,
                  meta: {
                    auth: true,
                  },
                },
                {
                  name: 'UsersEditUser',
                  path: ':id',
                  component: EditUser,
                  meta: {
                    auth: true,
                  },
                },
              ],
            },
          ],
        },
        {
          name: 'Products',
          path: 'products',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Products',
          },
          children: [
            {
              name: 'ProductsColorsMaps',
              path: 'colors/maps',
              component: ProductsColorsMaps,
              meta: {
                auth: true,
                breadcrumbs: 'Colors Maps',
              },
            },
            {
              name: 'ProductsSizesMaps',
              path: 'sizes/maps',
              component: ProductsSizesMaps,
              meta: {
                auth: true,
                breadcrumbs: 'Sizes Maps',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/admins',
      name: 'Admins',
      redirect: '/login',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [{
        path: '/login',
        name: 'Login',
        component: Login,
      }],
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Error404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Error500,
        },
      ],
    },
    {
      path: '*',
      redirect: '/pages/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (UserTokenService.getToken() === null) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
